import { configureStore } from '@reduxjs/toolkit'
import userReducer from './features/user/userSlice'
import dashBoardReducer from './features/dashboard/dashboardSlice'
export const store = configureStore({
 reducer: {
    user: userReducer,
    dashboard: dashBoardReducer
 },
})